module.exports = __webpack_public_path__ + "static/jobsity-559907071ebc24e58bf57b395c9297fb.png";